namespace $.$$ {
	export class $shm_hitalama_components_settings extends $.$shm_hitalama_components_settings {
		editable() { return this.definition().can_change() }
		widget_type( next?: boolean ) { return this.definition().widget_type( next ) }
		name( next?: string ) {
			if( next !== undefined ) return this.definition().title( next )
			const title = this.definition().title()
			return title === this.definition().class_name() ? this.definition().display_name() : title
		}
		fqn() { return this.definition().class_name() }
		remove_question() { return `Удалить из каталога ${ this.fqn() } и все его вложенные FQN-модули? Другие приложения, общие зависимости и GitHub-репозиторий останутся.` }
		catalog() { return this.definition().Owner_catalog()?.remote() ?? this.$.$shm_hitalama_components_catalog.current() }
		repository_owner() { return this.$.$shm_hitalama_components_owner.definition( this.definition() ) }
		repository_editable() { return this.repository_owner().can_change() }
		remove_enabled() { return this.editable() && !this.saving() && Boolean( this.catalog()?.can_change() ) }
		@ $mol_action
		remove( event?: Event | null ) {
			if( !event || !this.remove_enabled() ) return null
			const catalog = this.catalog()!
			$mol_wire_sync( catalog ).application_remove( this.fqn() )
			this.removed( event )
			return null
		}
		description( next?: string ) { return this.definition().Description( next === undefined ? undefined : null )?.val( next ) ?? '' }
		repository( next?: string ) {
			const owner = this.repository_owner()
			if( next !== undefined && !owner.can_change() ) throw new Error( 'Нет прав на изменение репозитория приложения.' )
			const manual = owner.Github_repository( next === undefined ? undefined : null )?.val( next === undefined ? undefined : next.trim() ) ?? ''
			return manual || this.$.$shm_hitalama_components_github.suggested_repository( owner.class_name(), this.$.$shm_hitalama_settings.github_owner() )
		}
		@ $mol_mem
		github() { return new this.$.$shm_hitalama_components_github }
		@ $mol_mem
		revision( next?: number ) { return next ?? 0 }
		@ $mol_mem
		remote() {
			const repo = this.repository().trim()
			if( !repo ) return null
			return $mol_wire_sync( this.github() ).read_optional( this.$.$shm_hitalama_components_github.repository( repo ), this.$.$shm_hitalama_settings.github_token(), this.revision() )
		}
		snapshot() { return JSON.stringify( this.$.$shm_hitalama_components_github.files( this.definition(), this.catalog() ) ) }
		@ $mol_mem
		changes() {
			const remote = this.remote()
			const changes = $mol_wire_sync( this.github() ).changes( this.$.$shm_hitalama_components_github.repository( this.repository() ), this.$.$shm_hitalama_settings.github_token(), this.snapshot(), remote )
			return [ ...changes.changed, ...changes.removed ]
		}
		status() {
			if( this.saving() ) return 'Сохраняется код приложения…'
			if( this.save_error() ) return this.save_error()
			if( !this.repository().trim() ) return 'Укажите владельца GitHub рядом с токеном в настройках либо задайте репозиторий вручную.'
			if( !this.remote() ) return 'При первом коммите будет создан закрытый репозиторий ' + this.repository() + '. Токен должен разрешать создание репозиториев у выбранного владельца.'
			const changes = this.changes()
			const noun = changes.length === 1 ? 'файл' : changes.length < 5 ? 'файла' : 'файлов'
			return changes.length ? 'Есть новые изменения: ' + changes.length + ' ' + noun + '.' : 'На GitHub актуальная версия.'
		}
		commit_enabled() {
			return this.$.$mol_error_fence( ()=> this.repository_editable() && Boolean( this.repository().trim() ) && !this.saving() && !this.save_error() && this.changes().length > 0, ()=> false )
		}
		sync_state() {
			return this.$.$mol_error_fence( ()=> this.save_error() ? 'error' : this.saving() ? 'active' : !this.repository().trim() ? '' : this.changes().length ? 'active' : 'success', ()=> 'error' )
		}
		@ $mol_action
		refresh( event?: Event ) { if( event ) this.revision( this.revision() + 1 ); return null }
		@ $mol_action
		commit( event?: Event ) {
			if( !event || !this.repository_editable() ) return null
			const request = $mol_wire_sync( this ).commit_request( event )
			if( !request ) return null
			$mol_wire_sync( this.github() ).save( request.repository, request.token, request.snapshot, request.head )
			this.repository_owner().Github_repository( null )!.val( request.repository )
			this.revision( this.revision() + 1 )
			return null
		}
		private commits = new WeakMap< Event, { repository: string, token: string, snapshot: string, head: string | null } >
		commit_request( event: Event ) {
			const previous = this.commits.get( event )
			if( previous ) return previous
			const remote = this.remote()
			const request = { repository: this.$.$shm_hitalama_components_github.repository( this.repository() ), token: this.$.$shm_hitalama_settings.github_token(), snapshot: this.snapshot(), head: remote?.head ?? null }
			this.commits.set( event, request )
			return request
		}
	}
}
